export const mockJR = [
    {
        ID: 6,
        target_date: '2024-11-30',
        requested_by_id: '6095',
        department: 'IT',
        campaign_support_dept: 'IT',
        headcount_required: 1,
        team_leader_headcount_required: 1,
        shift_pattern: 'India',
        working_hours_start_time: '10:10:00',
        working_hours_end_time: '08:08:00',
        vacancy_reason: 'New growth',
        type_of_employment: 'Permanent',
        duration_of_employment: 'NA',
        role_budget_Salary: '100000',
        Email: 'himanshu.jain@quantanite.com',
        sow_change_order_received: 'SoW Received',
        job_description: 'Must have reactjs knowledge',
        created_at: '2024-11-21T11:35:45',
        status: 'Pending',
        error: '',
        form_submit_conf: null,
        job_form_id: null,
        reviewed_by_id: null,
        reviewed_at: null,
        user_type: 'recruiter',
        table_name: 'job_request_india_form',
        modal_type: 'review',
        position_required: 'Frontend Developer',
        action: true,
    },
    {
        ID: 7,
        target_date: '2024-11-29',
        requested_by_id: '6095',
        department: 'Operations',
        campaign_support_dept: '23',
        headcount_required: 2,
        team_leader_headcount_required: 2,
        shift_pattern: 'India',
        working_hours_start_time: '11:11:00',
        working_hours_end_time: '23:33:00',
        vacancy_reason: 'New growth',
        type_of_employment: 'Permanent',
        duration_of_employment: '22',
        role_budget_Salary: '22332',
        Email: 'himanshu.jain@quantanite.com',
        sow_change_order_received: 'SoW Received',
        job_description: 'Frontend Developer with js ',
        created_at: '2024-11-21T12:06:05',
        status: 'Approved',
        error: '',
        form_submit_conf: null,
        job_form_id: 7,
        reviewed_by_id: '6095',
        reviewed_at: '2024-11-21T17:36:24',
        jd_Job_description:
            "# Frontend Developer at Quantanite\n\n## Job Summary:\nQuantanite is looking for a skilled Frontend Developer to join our Operations department due to new growth within the company. This is a permanent position where the successful candidate will play a pivotal role in developing and implementing front-end web applications that meet our business needs. The ideal candidate will have a strong understanding of front-end technologies, particularly JavaScript.\n\n## Key Responsibilities:\n- Develop and implement highly-responsive user interface components using JavaScript frameworks.\n- Work closely with our web development team to ensure the technical feasibility of UI/UX designs.\n- Optimize applications for maximum speed and scalability, ensuring all pages and features are fully functional across all browsers and devices.\n\n## Requirements:\n\n### Education:\n- Bachelor's degree in Computer Science, Information Technology, or a related field.\n\n### Experience:\n- 2+ years of experience in front-end development.\n\n### Skills:\n- Proficient understanding of web markup, including HTML5 and CSS3.\n- Strong understanding of client-side scripting and JavaScript frameworks.\n- Good understanding of asynchronous request handling, partial page updates, and AJAX.\n- Proficient understanding of cross-browser compatibility issues and ways to work around them.\n- Familiarity with front-end build tools, such as Grunt and Gulp.js.\n- Good understanding of SEO principles and ensuring that the application will adhere to them.\n\n### Work Environment:\n- This role follows an India shift pattern with working hours from 11:11 AM to 11:33 PM.\n- The position is based in our Operations department and requires collaboration with the campaign support team and other departments as necessary.\n\n### Additional Information:\n- This is a permanent role and part of our initiative for new growth within the company.\n- The role is budgeted with a salary of 22332.\n- Statement of Work (SoW) has been received, confirming the addition of this role to our team structure.\n- We are looking to fill 2 headcounts for this position, along with 2 team leader positions to ensure effective leadership and guidance for our expanding team.\n\nQuantanite offers a dynamic and challenging environment where innovation and proactive behavior are encouraged. If you are passionate about frontend development and looking to make a significant impact in a growing company, we would love to hear from you.",
        user_type: 'recruiter',
        table_name: 'job_request_india_form',
        modal_type: 'review',
        emp_name: 'Himanshu Jain',
        position_required: 'Frontend Developer',
        action: true,
    },
    {
        ID: 5,
        target_date: '2024-11-22',
        requested_by_id: '4882',
        department: 'IT',
        campaign_support_dept: 'BBB',
        headcount_required: 1,
        team_leader_headcount_required: 1,
        shift_pattern: 'India',
        working_hours_start_time: '11:11:00',
        working_hours_end_time: '01:11:00',
        vacancy_reason: 'New growth',
        type_of_employment: 'Permanent',
        duration_of_employment: 'NA',
        role_budget_Salary: '12000',
        Email: 'anand.yadav@quantanite.com',
        sow_change_order_received: 'Change Order Received',
        job_description: 'Exp 3 year, must have Django \n',
        created_at: '2024-11-21T09:33:51',
        status: 'Pending',
        error: '',
        form_submit_conf: null,
        job_form_id: 5,
        reviewed_by_id: '6095',
        reviewed_at: '2024-11-21T15:19:44',
        jd_Job_description:
            "# AI Engineer at Quantanite\n\n## Job Summary:\nWe are seeking a skilled AI Engineer to join our IT department at Quantanite, a company currently experiencing exciting new growth. This role is aimed at professionals who are passionate about leveraging artificial intelligence to solve complex problems and contribute to significant projects. As an AI Engineer, you'll have the unique opportunity to work on cutting-edge technologies in a dynamic environment.\n\n## Key Responsibilities:\n- **Develop and implement AI models and algorithms**: You will be responsible for creating efficient AI models and algorithms to meet the project requirements.\n- **Optimize and maintain existing AI systems**: Ensure the current AI systems operate at their maximum efficiency and update them as needed.\n- **Collaborate with cross-functional teams**: Work closely with other departments, including the BBB campaign support dept, to integrate AI solutions that enhance operational efficiency and effectiveness.\n\n## Requirements:\n**Education:** Bachelor’s Degree in Computer Science, Artificial Intelligence, or related field.\n\n**Experience:** 3 years of experience in the industry, with a strong background in AI technologies and proficiency in Django.\n\n**Skills:**\n- Expertise in AI and machine learning algorithms and models\n- Proficient in Django and other relevant programming languages and frameworks\n- Strong analytical and problem-solving abilities\n- Excellent communication and teamwork skills\n\n**Work Environment:** This position follows the India shift pattern, with working hours from 11:11 to 01:11. It's a permanent role, benefiting from a work culture that promotes growth, learning, and collaboration.\n\n**Additional Information:**\n- **Type of Employment:** Permanent\n- **Role Budget/Salary:** 12000\n- **Vacancy Reason:** The role is created due to the new growth phase of the company.\n- **SOW Change Order Received:** Change Order Received\n\nAs an AI Engineer at Quantanite, you will play a vital role in driving our AI initiatives forward, contributing to projects that make a real difference. If you are looking to further your career in AI and possess the required skills and experience, we encourage you to apply and join our innovative team.",
        user_type: 'recruiter',
        table_name: 'job_request_india_form',
        modal_type: 'review',
        emp_name: 'Himanshu Jain',
        position_required: 'AI Engineer',
        action: true,
    },
    {
        job_form_id: 7,
        reviewed_by_user: null,
        actioned_at: '2024-11-21T17:37:10.397000',
        ID: 7,
        target_date: '2024-11-29',
        requested_by_id: '6095',
        department: 'Operations',
        campaign_support_dept: '23',
        headcount_required: 2,
        team_leader_headcount_required: 2,
        shift_pattern: 'India',
        working_hours_start_time: '11:11:00',
        working_hours_end_time: '23:33:00',
        vacancy_reason: 'New growth',
        type_of_employment: 'Permanent',
        duration_of_employment: '22',
        role_budget_Salary: '22332',
        Email: 'himanshu.jain@quantanite.com',
        sow_change_order_received: 'SoW Received',
        job_description: 'Frontend Developer with js ',
        created_at: '2024-11-21T12:06:05',
        status: 'Approved',
        error: '',
        form_submit_conf: null,
        user_type: 'manager',
        table_name: 'job_request_india_form',
        position_required: 'Frontend Developer',
        action: true,
    },
];
